// extracted by mini-css-extract-plugin
module.exports = {"block":"style-module--block--3L22V","overlay":"style-module--overlay--30EGi","background":"style-module--background--3SzN2","content":"style-module--content--52aiw"};